<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div class="full-page-bg-color" slot="no-body">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img alt="login" class="mx-auto lg:w-1/2" src="../../public/logoPraqtLogin.png">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center bg-white">
                            <form class="p-8" @submit="e => e.preventDefault()">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Autenticar</h4>
                                    <p>Seja bem-vindo, por favor informe seu e-mail e senha.</p>
                                </div>
                                <vs-input autofocus :color="errors.has('email') ? 'danger' : 'success'"
                                          class="w-full mb-6 no-icon-border" icon="icon icon-user"
                                          icon-pack="feather" label-placeholder="E-mail" name="email"
                                          v-model="form.email"
                                          v-validate="'required|email'"
                                />
                                <span class="text-danger">{{ errors.first('email') }}</span>
                                <vs-input class="w-full mb-4 no-icon-border" icon="icon icon-lock" icon-pack="feather"
                                          label-placeholder="Senha" name="senha"
                                          type="password" v-model="form.senha"
                                          v-validate="'required|min:6'"/>
                                <span class="text-danger">{{ errors.first('senha') }}</span>
                                <!--<div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox class="mb-3" v-model="form.lembrar">Lembrar</vs-checkbox>
                                    <router-link to="/pages/forgot-password">Esqueci a senha?</router-link>
                                </div>-->
                                <div class="flex flex-wrap justify-end my-5">
                                    <vs-button @click="validate" class="float-right">Entrar</vs-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        data() {
            return {
                form: {
                    email: '',
                    senha: '',
                    lembrar: false,
                },
            }
        },
        methods: {
            ...mapActions(['login', 'logout']),
            validate() {
                this.$validator.validateAll().then(result => {
                    if (result) this.auth();
                })
            },
            setAxiosToken(authToken) {
                this.$axios.interceptors.request.use(config => {
                    config.headers['Authorization'] = `Bearer ${authToken}`;
                    return config;
                });
            },
            auth() {
                this.$axios.post('/auth/login', this.form).then(async ({data}) => {
                    const {token: authToken, me: user} = data;

                    this.setAxiosToken(authToken);

                    await this.login({
                        authToken,
                        user
                    });
                    this.$router.push(this.$route.query.redirect || "/");
                }).catch(({message}) => {
                    this.$vs.notify(
                        {
                            title: 'Erro',
                            text: message,
                            color: "rgb(242, 19, 93)",
                            position: 'top-right',
                            time: 5000
                        }
                    )
                })
            }
        }
    }
</script>
